import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    filterSelectors,
    searchSelectors,
    tripSelectors,
} from 'wanderu-ducks-search';
import { widgetDataSelectors } from 'wanderu-ducks-widget';

import SearchList from '../../components/SearchList/SearchList';

function SearchListContainer(props) {
    const {
        onSelect,
        onResetAllFilters,
        numberOfActiveFilters,
        ...reduxProps
    } = props;
    const showReset = numberOfActiveFilters > 0;

    return (
        <SearchList
            {...reduxProps}
            onResetAllFilters={onResetAllFilters}
            onSelect={onSelect}
            showReset={showReset}
        />
    );
}

SearchListContainer.propTypes = {
    numberOfActiveFilters: PropTypes.number,
    onResetAllFilters: PropTypes.func,
    onSelect: PropTypes.func,
};

function mapStateToProps(state, ownProps) {
    const { direction } = ownProps;
    const searchParams = searchSelectors.selectReduxSearchParams(state, direction);

    return {
        activeSortType: filterSelectors.selectActiveSortType(state, searchParams),
        batchId: searchSelectors.selectBatchId(state, searchParams),
        direction,
        paxCount: parseInt(widgetDataSelectors.selectPassengersInput(state), 10) || 1,
        searchParams,
        tripMetadata: tripSelectors.selectTripMetadata(state, searchParams),
        trips: tripSelectors.selectFilteredAndSortedTrips(state, searchParams),
    };
}

export {
    SearchListContainer,
    mapStateToProps,
};
export default connect(mapStateToProps)(SearchListContainer);
